import { Contact } from '@/shared/interfaces/Contact'
import { ApiHandler } from '../ApiHandler'

export abstract class ContactsApi {
    /**
    * Получить список контактов пользователя. Объект класса Contact необходим только для персонализации отображения имени и фамилии другого пользователя у текущего пользователя, для всех взаимодействий необходимо использовать user.id
    */
    public static async get(): Promise<Contact[]> {
        return await ApiHandler.get('contacts')
    }

    public static async getByUser(id: number): Promise<Contact> {
        return await ApiHandler.get(`contacts/${id}`)
    }

    /**
    * Добавление новых контактов пользователя. Контакт добавляется только в том случае, если пользователь существует
    */
    public static async create(contacts: { firstname: string, lastname: string, phone: string }[]): Promise<{ value_created_contacts: number, value_existing_contacts: number, value_non_existent_phonebook_contacts: number, value_forbidden_contacts: number, created_contacts: Contact[], existing_contacts: Contact[] }> {
        return await ApiHandler.post('contacts', {
            phonebook_contacts: contacts.map((contact) => {
                return {
                    name: contact.firstname,
                    surname: contact.lastname,
                    phone: contact.phone,
                }
            }),
        })
    }

    /**
   * Обновить контакт пользователя
   */
    public static async edit(contactId: number, firstname: string, lastname: string): Promise<any> {
        return ApiHandler.patch(`contacts/${contactId}`, {
            name: firstname,
            surname: lastname,
        })
    }

    /**
    * Удалить контакт пользователя
    */
    public static async delete(contactId: number): Promise<void> {
        return await ApiHandler.delete('contacts', {
            contact_id: contactId,
        })
    }
}